import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminLayout from './components/AdminLayout';

const Reports = () => {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState('daily');
  const [reportData, setReportData] = useState({
    totalSales: 0,
    totalOrders: 0,
    averageOrder: 0
  });

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    calculateReport();
  }, [orders, filter]);

  const fetchOrders = async () => {
    try {
      const response = await axios.get('http://localhost:5000/api/orders');
      setOrders(response.data);
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  const calculateReport = () => {
    const now = new Date();
    let filteredOrders = [];

    if (filter === 'daily') {
      filteredOrders = orders.filter(order => {
        const orderDate = new Date(order.order_date);
        return orderDate.toDateString() === now.toDateString();
      });
    } else if (filter === 'monthly') {
      filteredOrders = orders.filter(order => {
        const orderDate = new Date(order.order_date);
        return orderDate.getMonth() === now.getMonth() && 
               orderDate.getFullYear() === now.getFullYear();
      });
    } else {
      filteredOrders = orders; // all time
    }

    const totalSales = filteredOrders.reduce((sum, order) => sum + (order.amount_paid || 0), 0);
    const totalOrders = filteredOrders.length;
    const averageOrder = totalOrders > 0 ? totalSales / totalOrders : 0;

    setReportData({
      totalSales,
      totalOrders,
      averageOrder
    });
  };

  const getFilteredOrders = () => {
    const now = new Date();
    
    if (filter === 'daily') {
      return orders.filter(order => {
        const orderDate = new Date(order.order_date);
        return orderDate.toDateString() === now.toDateString();
      });
    } else if (filter === 'monthly') {
      return orders.filter(order => {
        const orderDate = new Date(order.order_date);
        return orderDate.getMonth() === now.getMonth() && 
               orderDate.getFullYear() === now.getFullYear();
      });
    }
    
    return orders;
  };

  return (
    <AdminLayout>
      <div className="admin-content">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Sales Reports</h2>
          <div>
            <select 
              className="form-select"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              <option value="daily">Daily Report</option>
              <option value="monthly">Monthly Report</option>
              <option value="all">All Time</option>
            </select>
          </div>
        </div>

        {/* Summary Cards */}
        <div className="row mb-4">
          <div className="col-md-4">
            <div className="stat-card">
              <h3>₹{reportData.totalSales.toFixed(2)}</h3>
              <p>Total Sales</p>
              <i className="fas fa-rupee-sign fa-2x text-success"></i>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stat-card">
              <h3>{reportData.totalOrders}</h3>
              <p>Total Orders</p>
              <i className="fas fa-shopping-cart fa-2x text-primary"></i>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stat-card">
              <h3>₹{reportData.averageOrder.toFixed(2)}</h3>
              <p>Average Order Value</p>
              <i className="fas fa-chart-line fa-2x text-info"></i>
            </div>
          </div>
        </div>

        {/* Orders Table */}
        <div className="data-table">
          <h4 className="mb-3">
            {filter === 'daily' ? "Today's" : filter === 'monthly' ? "This Month's" : "All"} Orders
          </h4>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Service</th>
                <th>Amount (₹)</th>
                <th>Paid (₹)</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {getFilteredOrders().map(order => (
                <tr key={order.id}>
                  <td>#{order.id}</td>
                  <td>{order.customer_name}</td>
                  <td>{order.service_name}</td>
                  <td>₹{order.total_amount}</td>
                  <td>₹{order.amount_paid}</td>
                  <td>
                    <span className={`badge ${
                      order.status === 'Delivered' ? 'bg-success' :
                      order.status === 'Completed' ? 'bg-warning' :
                      order.status === 'In Progress' ? 'bg-primary' : 'bg-secondary'
                    }`}>
                      {order.status}
                    </span>
                  </td>
                  <td>{new Date(order.order_date).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {getFilteredOrders().length === 0 && (
            <div className="text-center py-4">
              <p>No orders found for the selected period.</p>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default Reports;